import React from 'react';
import { BsTrash3 } from 'react-icons/bs';

const FILTER_DEFAULTS = {
  split: { type: 'split', delimiter: ',', keep: 1 },
  exclude: { type: 'exclude', tokens: '' },
  regex: { type: 'regex', pattern: '' },
  relative_date: {
    type: 'relative_date',
    mapText: 'Hoy=0,Manana=1,Mañana=1',
    timezone: 'America/Bogota',
    outputFormat: 'YYYY-MM-DD',
    defaultTime: '00:00:00',
  },
  format_date: {
    type: 'format_date',
    inputFormat: '',
    timezone: 'America/Bogota',
    outputFormat: 'YYYY-MM-DD',
    defaultTime: '00:00:00',
  },
};

// Filtros de limpieza que el motor aplica al valor antes de guardarlo
// (mismos que usa add_saveAnswer: split, exclude, regex, relative_date, format_date).
const ValueFiltersEditor = ({ filters = [], onChange, isDark, accentColor = '#D89C7E' }) => {
  const dark = isDark == 'true' || isDark === true;

  const addFilter = () => onChange([...filters, { ...FILTER_DEFAULTS.split }]);
  const removeFilter = (index) => onChange(filters.filter((_, i) => i !== index));
  const updateFilter = (index, key, value) =>
    onChange(
      filters.map((filter, i) => {
        if (i !== index) return filter;
        if (key === 'type') return { ...(FILTER_DEFAULTS[value] || { type: value }) };
        return { ...filter, [key]: value };
      })
    );

  return (
    <div className="mt-2 pt-2" style={{ borderTop: dark ? '1px dashed #495057' : '1px dashed #dee2e6' }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span style={{ fontSize: '11px', fontWeight: 700, color: accentColor }}>FILTROS DE LIMPIEZA</span>
        <button
          type="button"
          className="btn btn-xs btn-link p-0"
          onClick={addFilter}
          style={{ fontSize: '11px', color: '#007bff', textDecoration: 'none' }}
        >
          + Añadir regla
        </button>
      </div>

      {filters.map((filter, fIndex) => (
        <div key={fIndex} className="p-2 mb-2 rounded" style={{ backgroundColor: dark ? '#111B21' : '#f8f9fa', border: '1px solid #dee2e6' }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <select
              className="form-control form-control-sm w-75"
              style={{ fontSize: '11px', height: '24px' }}
              value={filter.type}
              onChange={(e) => updateFilter(fIndex, 'type', e.target.value)}
            >
              <option value="split">Recortar (Split)</option>
              <option value="exclude">Excluir palabras</option>
              <option value="regex">Regex (Eliminar patrón)</option>
              <option value="relative_date">Fecha relativa (Hoy/Mañana)</option>
              <option value="format_date">Formatear fecha</option>
            </select>
            <BsTrash3
              className="text-danger pointer"
              style={{ fontSize: '12px' }}
              onClick={() => removeFilter(fIndex)}
            />
          </div>

          {filter.type === 'split' && (
            <div className="d-flex gap-2">
              <input
                className="form-control form-control-sm"
                placeholder="Delimitador (ej: ,)"
                value={filter.delimiter}
                onChange={(e) => updateFilter(fIndex, 'delimiter', e.target.value)}
              />
              <input
                type="number"
                className="form-control form-control-sm"
                placeholder="Partes"
                value={filter.keep}
                onChange={(e) => updateFilter(fIndex, 'keep', e.target.value)}
              />
            </div>
          )}

          {filter.type === 'exclude' && (
            <input
              className="form-control form-control-sm"
              placeholder="Colombia, Medellin, 524060..."
              value={filter.tokens}
              onChange={(e) => updateFilter(fIndex, 'tokens', e.target.value)}
            />
          )}

          {filter.type === 'regex' && (
            <input
              className="form-control form-control-sm"
              placeholder="Patrón (ej: \d{5,6})"
              value={filter.pattern}
              onChange={(e) => updateFilter(fIndex, 'pattern', e.target.value)}
            />
          )}

          {filter.type === 'relative_date' && (
            <div className="d-flex flex-column gap-2">
              <input
                className="form-control form-control-sm"
                placeholder="Mapa (ej: Hoy=0,Manana=1,Mañana=1)"
                value={filter.mapText || ''}
                onChange={(e) => updateFilter(fIndex, 'mapText', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Timezone (ej: America/Bogota)"
                value={filter.timezone || ''}
                onChange={(e) => updateFilter(fIndex, 'timezone', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Formato salida (ej: YYYY-MM-DD)"
                value={filter.outputFormat || ''}
                onChange={(e) => updateFilter(fIndex, 'outputFormat', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Hora por defecto (ej: 00:00:00)"
                value={filter.defaultTime || ''}
                onChange={(e) => updateFilter(fIndex, 'defaultTime', e.target.value)}
              />
            </div>
          )}

          {filter.type === 'format_date' && (
            <div className="d-flex flex-column gap-2">
              <input
                className="form-control form-control-sm"
                placeholder="Formato entrada (opcional, ej: DD/MM/YYYY)"
                value={filter.inputFormat || ''}
                onChange={(e) => updateFilter(fIndex, 'inputFormat', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Timezone (ej: America/Bogota)"
                value={filter.timezone || ''}
                onChange={(e) => updateFilter(fIndex, 'timezone', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Formato salida (ej: YYYY-MM-DD HH:mm:ss)"
                value={filter.outputFormat || ''}
                onChange={(e) => updateFilter(fIndex, 'outputFormat', e.target.value)}
              />
              <input
                className="form-control form-control-sm"
                placeholder="Hora por defecto (ej: 00:00:00)"
                value={filter.defaultTime || ''}
                onChange={(e) => updateFilter(fIndex, 'defaultTime', e.target.value)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ValueFiltersEditor;
